import { endpoints, request } from '!core/api';

export const trlChartsServices = {
  instrumentGraphQuotes: ({ symbol, exchange, securityType, period }) => {
    const periodValue = period ? `&period=${period}` : '';

    return request.get(
      endpoints.chnn(
        `wsbGetInstrumentGraphQuotes?symbol=${symbol}&exchange=${exchange}&securityType=${securityType}${periodValue}`,
      ),
    );
  },
};
